import React from "react";
import { Field, ErrorMessage } from "formik";
import styles from "./Date.module.scss";
import ErrorText from "components/shared/errortext/ErrorText";
import { combineClasses } from "utils/utils";

const Date = (props) => {
  const {
    label,
    name,
    icon,
    placeholder,
    isRequired,
    inputClassName,
    type,
    ...rest
  } = props;

  return (
    <div className={styles.inputControl}>
      <label className={styles.label} htmlFor={name}>
        {label}{" "}
        {isRequired ? <span className={styles.requiredMark}>*</span> : ""}
      </label>
      <Field name={name}>
        {({ field }) => {
          return (
            <input
              {...field}
              {...rest}
              id={name}
              type={type}
              className={combineClasses(styles.inputField, inputClassName)}
              placeholder={placeholder}
            />
          );
        }}
      </Field>
      <ErrorMessage name={name} component={ErrorText} />
    </div>
  );
};

export default Date;
